import client from './client';

export const fastingApi = {
  getActive: () => client.get('/fasting/active'),
  start: (preset, customHours) =>
    client.post('/fasting/start', {
      preset,
      ...(customHours != null ? { custom_hours: customHours } : {}),
    }),
  end: () => client.post('/fasting/end'),
  history: (limit = 30) => client.get('/fasting/history', { params: { limit } }),
  stats: () => client.get('/fasting/stats'),
  setClientProtocol: (clientId, preset, customHours) =>
    client.post(`/fasting/clients/${clientId}/protocol`, {
      preset,
      ...(customHours != null ? { custom_hours: customHours } : {}),
    }),
  clearClientProtocol: (clientId) => client.delete(`/fasting/clients/${clientId}/protocol`),
};
